// import Service from "../../../service/api"

const NecessaryModule = {
    namespaced: true,
    state: {
        courseCode: "",
        courseObjectId: "",
        userCourse: "",
        learningCourse: [],
        userinfo: [],
        testmode: false,
        assingmentmode: false,
        pretestMode: false,
        posttestMode: false,
        topicID: 0,
        mode: {},
        score: 0,
        LKAScore: 0,
        lessonActive: 0,
        code: "",
        pretestScore: 0,
        tmpScore: 0,
        section: {},
        userCourseSection: null,
        menuLock: []
    },
    mutations: {
        setDataCourse(state, res) {
            state.courseCode = res.courseCode;
            state.courseObjectId = res.objectId;
        },
        setUserCourseSection(state, res) {
            state.userCourseSection = res
        },
        setLearningCourse(state, res) {
            console.log('setLearningCourse', res)
            state.learningCourse = res;
        },
        setCourseOverview(state, res) {
            console.log('setCourseOverview', res)
            state.userCourse = res;
        },
        setCourseOverviewLogOut(state) {
            state.userCourse = [];
        },
        setUserinfo(state, res) {
            state.userinfo = res;
        },
        setTestMode(state) {
            state.testmode = true;
            state.assingmentmode = false;
        },
        setScore(state, value) {
            state.score += value;
        },
        setLKAScore(state, val) {
            state.LKAScore = val;
        },
        setScoreToZero(state) {
            state.score = 0;
        },
        setLKAScoreToZero(state) {
            state.LKAScore = 0;
        },
        setPretestScore(state, res) {
            state.pretestScore = res;
        },
        setDefaultMode(state) {
            state.mode.testmode = false;
            state.mode.assingmentmode = false;
            state.mode.pretestMode = false;
            state.mode.posttestMode = false;
        },
        setTopicID(state, res) {
            state.topicID = res;
        },
        setMode(state, res) {
            if (res.type == "TEST") {
                state.mode.testmode = res.mode;
                state.mode.assingmentmode = false;
                state.mode.pretestMode = false;
                state.mode.posttestMode = false;
            } else if (res.type == "ASSIGNMENT") {
                state.mode.testmode = false;
                state.mode.assingmentmode = res.mode;
                state.mode.pretestMode = false;
                state.mode.posttestMode = false;
            } else if (res.type == "PRETEST") {
                state.mode.testmode = false;
                state.mode.assingmentmode = false;
                state.mode.pretestMode = res.mode;
                state.mode.posttestMode = false;
            } else if (res.type == "POSTTEST") {
                state.mode.testmode = false;
                state.mode.assingmentmode = false;
                state.mode.pretestMode = false;
                state.mode.posttestMode = res.mode;
            }
        },
        setLessonActive(state, res) {
            state.lessonActive = res;
        },
        setCodePage(state, res) {
            state.code = res;
        },
        setScore(state, res) {
            state.tmpScore += res;
        },
        setClearScore(state, res) {
            state.tmpScore = res;
        },
        setInstructorSection(state, res) {
            state.section = res
        },
        setMenuLockChinese2(state, res) {
            state.menuLock = res
        }
    },
    getters: {
        getDataCourse(state) {
            return state.courseObjectId;
        },
        getCourseObjectId(state) {
            return state.courseObjectId;
        },
        getUserEnrolledCourse(state) {
            return state.userCourse;
        },
        getLerningCourse(state) {
            return state.learningCourse;
        },
        getUserinfo(state) {
            return state.userinfo;
        },
        getMode(state) {
            return state.mode;
        },
        getTopicID(state) {
            return state.topicID;
        },
        getScoreLKI(state) {
            return state.score;
        },
        getLKAScore(state) {
            return state.LKAScore;
        },
        getLessonActive(state) {
            return state.lessonActive;
        },
        getCodePage(state) {
            return state.code;
        },
        getPretestScore(state) {
            return state.pretestScore;
        },
        getTmpScore(state) {
            return state.tmpScore;
        },
        getInstructorSection(state) {
            return state.section;
        },
        getUserCourseSection(state) {
            return state.userCourseSection;
        },
        getMenuLockChinese2(state) {
            return state.menuLock;
        }
    },
};

export default NecessaryModule;